import clamp from 'lodash/clamp';
import range from 'lodash/range';

import type { RestrictionItem } from '../types';

export const isItemClickable = (
  item: RestrictionItem
): item is RestrictionItem & {
  manifestId: string;
  startLine: number;
  endLine: number;
} => {
  return (
    item.manifestId !== undefined &&
    item.startLine !== undefined &&
    item.endLine !== undefined
  );
};

export const buildLineRange = (
  startLine: number,
  endLine: number
): number[] => {
  const start = clamp(startLine, 1, Number.MAX_SAFE_INTEGER);
  const end = Math.max(start, endLine);
  return range(start, end + 1);
};

export const addLineRangeToSet = (
  set: Set<number>,
  startLine: number,
  endLine: number
): void => {
  buildLineRange(startLine, endLine).forEach((line) => set.add(line));
};
